export default __webpack_public_path__ + "static/media/ic_search.11da44a0.svg";